<template>
    <div id="TopContainerPanel">        
        <slot />
    </div>
</template>

<script>

    import Auth from '../services/Auth';
    

    //components
    import AssignmentTitle from './AssignmentTitle.vue';
    import AssignmentScore from './AssignmentScore.vue';

    export default {
        components: {
            AssignmentTitle,
            AssignmentScore
        },
        props: {
        },
        watch: {
            score: function(newVal, oldVal) {
                this.scoreData = this.score;
            }
        },
        data()
        {
            return {
                scoreData: null
            }
        }
    }
    
</script>
